// src/components/sonner.tsx
import { useTheme } from "next-themes";
import { Toaster as Sonner, toast as sonnerToast } from "sonner";
import { jsx } from "react/jsx-runtime";
var BASE_TOAST_STYLES = {
  toastOptions: {
    classNames: {
      title: "text-small! font-bold!",
      closeButton: "text-black!",
      description: "text-small!",
      actionButton: "px-2.5! py-1.5! border! rounded!"
    }
  }
};
var TOAST_VARIANTS = {
  error: {
    style: { background: "var(--danger-600)", color: "#fff" },
    classNames: {
      title: "text-white!",
      description: "text-white/90!",
      closeButton: "bg-white!",
      actionButton: "border-white! opacity-90! bg-inherit!"
    }
  },
  success: {
    style: { background: "#fff", color: "#000" },
    classNames: {
      title: "text-black!",
      description: "text-black/70!",
      closeButton: "bg-gray-100!",
      actionButton: "border-black/25!"
    }
  },
  warning: {
    style: { background: "#fff", color: "#000" },
    classNames: {
      title: "text-black!",
      description: "text-black/70!",
      closeButton: "bg-gray-100!",
      actionButton: "border-black/25!"
    }
  },
  info: {
    style: { background: "#fff", color: "#000" },
    classNames: {
      title: "text-black!",
      description: "text-black/70!",
      closeButton: "bg-gray-100!",
      actionButton: "border-black/25!"
    }
  }
};
var toast = {
  error: (message, options = {}) => {
    const { classNames: optClassNames, ...rest } = options;
    return sonnerToast.error(message, {
      icon: null,
      style: TOAST_VARIANTS.error.style,
      classNames: {
        title: `${BASE_TOAST_STYLES.toastOptions.classNames.title} ${TOAST_VARIANTS.error.classNames.title}`,
        description: `${BASE_TOAST_STYLES.toastOptions.classNames.description} ${TOAST_VARIANTS.error.classNames.description}`,
        actionButton: `${BASE_TOAST_STYLES.toastOptions.classNames.actionButton} ${TOAST_VARIANTS.error.classNames.actionButton}`,
        closeButton: TOAST_VARIANTS.error.classNames.closeButton,
        ...optClassNames
      },
      ...rest
    });
  },
  success: (message, options = {}) => {
    const { classNames: optClassNames, ...rest } = options;
    return sonnerToast.success(message, {
      icon: null,
      style: TOAST_VARIANTS.success.style,
      classNames: {
        title: `${BASE_TOAST_STYLES.toastOptions.classNames.title} ${TOAST_VARIANTS.success.classNames.title}`,
        description: `${BASE_TOAST_STYLES.toastOptions.classNames.description} ${TOAST_VARIANTS.success.classNames.description}`,
        actionButton: `${BASE_TOAST_STYLES.toastOptions.classNames.actionButton} ${TOAST_VARIANTS.success.classNames.actionButton}`,
        closeButton: TOAST_VARIANTS.success.classNames.closeButton,
        ...optClassNames
      },
      ...rest
    });
  },
  warning: (message, options = {}) => {
    const { classNames: optClassNames, ...rest } = options;
    return sonnerToast.warning(message, {
      icon: null,
      style: TOAST_VARIANTS.warning.style,
      classNames: {
        title: `${BASE_TOAST_STYLES.toastOptions.classNames.title} ${TOAST_VARIANTS.warning.classNames.title}`,
        description: `${BASE_TOAST_STYLES.toastOptions.classNames.description} ${TOAST_VARIANTS.warning.classNames.description}`,
        actionButton: BASE_TOAST_STYLES.toastOptions.classNames.actionButton,
        closeButton: TOAST_VARIANTS.warning.classNames.closeButton,
        ...optClassNames
      },
      ...rest
    });
  },
  info: (message, options = {}) => {
    const { classNames: optClassNames, ...rest } = options;
    return sonnerToast.info(message, {
      icon: null,
      style: TOAST_VARIANTS.info.style,
      classNames: {
        title: `${BASE_TOAST_STYLES.toastOptions.classNames.title} ${TOAST_VARIANTS.info.classNames.title}`,
        description: `${BASE_TOAST_STYLES.toastOptions.classNames.description} ${TOAST_VARIANTS.info.classNames.description}`,
        actionButton: BASE_TOAST_STYLES.toastOptions.classNames.actionButton,
        closeButton: TOAST_VARIANTS.info.classNames.closeButton,
        ...optClassNames
      },
      ...rest
    });
  },
  unifiedPlatformError: (message, options = {}) => {
    const { classNames: optClassNames, ...rest } = options;
    return sonnerToast.error(message, {
      position: "bottom-center",
      style: { background: "#fff", color: "#000" },
      classNames: {
        title: "text-small! font-medium! text-black!",
        description: "text-small! text-black/70!",
        actionButton: `${BASE_TOAST_STYLES.toastOptions.classNames.actionButton} border-black/25!`,
        closeButton: "bg-gray-100!",
        icon: "text-red-500!",
        ...optClassNames
      },
      ...rest
    });
  },
  dismiss: sonnerToast.dismiss
};
var Toaster = ({ toastOptions, ...props }) => {
  var _a, _b, _c;
  const { theme = "system" } = useTheme();
  return /* @__PURE__ */ jsx(
    Sonner,
    {
      theme,
      className: "toaster group",
      style: {
        "--width": "500px",
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)"
      },
      toastOptions: {
        ...toastOptions,
        classNames: {
          ...toastOptions == null ? void 0 : toastOptions.classNames,
          toast: `w-fit! max-w-[500px]! left-0! right-0! mx-auto! ${((_a = toastOptions == null ? void 0 : toastOptions.classNames) == null ? void 0 : _a.toast) ?? ""}`,
          title: `line-clamp-2! ${((_b = toastOptions == null ? void 0 : toastOptions.classNames) == null ? void 0 : _b.title) ?? ""}`,
          description: `truncate ${((_c = toastOptions == null ? void 0 : toastOptions.classNames) == null ? void 0 : _c.description) ?? ""}`
        }
      },
      ...props
    }
  );
};
export {
  Toaster,
  toast
};
//# sourceMappingURL=sonner.js.map